export const REALDB_CONSTANT = {
  Sellersdata: "/premiere_2026_jwc/Sellersdata",
  SellerBaseData: "/premiere_2026_jwc/SellerBaseData",
};
